import { createContext } from 'react';

export const MarginTopContext = createContext({});
